/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-email-endpoints-searchview-component.ts
 *
 * Created by randysorensen on 10/2/17.
 */

'use strict';

function ContactsSelectModalController (this: JS5Object, _: JS5Object, uiGridConstants: JS5Object,
		ContactsService: JS5Object) {

	let enabledHeaderTemplate = 'components/visual/grid/header-check-mark-component-template.html';

	//=================//
	// Lifecycle Hooks //
	//=================//

	this.$onInit = () => {
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.searchText = '';
		this.existingContactIds = this.resolve.existingContactIds;

		ContactsService
			.getContactsList()
			.then((contacts: JS5Object[]) => {
				// Remove contacts that are specified in
				// this.resolve.existingContacts
				_.remove(contacts, (contact: JS5Object): boolean => {
					return _.includes(this.resolve.existingContactIds, contact.id);
				});

				this.contactsGridOptions.data = contacts;
			});
	};


	//===============//
	// Contacts Grid //
	//===============//

	let contactsGridColDefs = [
		{
			name: 'checkMarkRowHeaderCol',
			field: 'checkMark',
			width: 30,
			enableColumnMenu: false,
			enableSorting: false,
			enableColumnResizing: false,
			headerCellTemplate: enabledHeaderTemplate,
			cellTemplate: 'components/visual/grid/check-mark-template.html'
		},
		{
			field: 'firstName',
			type: 'string',
			width: '25%',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 2
			},
			displayName: 'First Name',
		},
		{
			field: 'lastName',
			type: 'string',
			width: '25%',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 1
			},
			displayName: 'Last Name',
		},
		{
			field: 'emailAddress',
			type: 'string',
			width: '*',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 3
			},
			displayName: 'Email Address',
		},
	];

	this.contactsGridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: true,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		multiSelect: true,
		columnDefs: contactsGridColDefs,
		onRegisterApi: (gridApi: JS5Object): void => {
			this.contactsGridApi = gridApi;
			this.contactsGridApi.grid.registerRowsProcessor(processGridFilter, 200);
		},
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		data: []
	};

	let processGridFilter = (renderableRows: JS5Object[]): JS5Object[] => {
		_.forEach(renderableRows, (row: JS5Object): void => {
			if (this.searchText === null || this.searchText === '') {
				row.visible = true;
			} else {
				let criteria: string = this.searchText.toLowerCase();
				row.visible =
					row.entity.firstName && row.entity.firstName.toLowerCase().indexOf(criteria) !== -1 ||
					row.entity.lastName && row.entity.lastName.toLowerCase().indexOf(criteria) !== -1 ||
					row.entity.emailAddress && row.entity.emailAddress.toLowerCase().indexOf(criteria) !== -1;
			}
		});
		return renderableRows;
	};

	this.executeSearch = (searchText: string): void => {
        this.searchText = searchText;
		this.contactsGridApi.grid.refresh();
	};

	this.onSelectAllToggled = ($event: JS5Object): void => {
		if (this.contactsGridApi.selection.getSelectAllState()) {
			this.contactsGridApi.selection.clearSelectedRows();
		} else {
			this.contactsGridApi.selection.selectAllVisibleRows();
		}
	};


	//================//
	// Template Logic //
	//================//

	this.getSelectedCount = (): number => {
		return (
			this.contactsGridApi &&
			this.contactsGridApi.selection &&
			this.contactsGridApi.selection.getSelectedCount()
		);
	};

	this.onOk = (): void => {
		this.close({
			$value: this.contactsGridApi.selection.getSelectedRows()
		});
	};
}

angular
.module('prism-ui.components')
.component(
	'contactsSelectModal',
	{
		controller: ContactsSelectModalController,
		templateUrl: 'components/modal/contactsSelectModal/contacts-select-modal-template.html',
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
		}
	}
);
